import React, { useState } from 'react';
import Meta from '../../atoms/meta';
import { faShare } from '@fortawesome/pro-solid-svg-icons';
import PageHeader from '../../organisms/page-header';
import { BulkPMPayload } from '../../organisms/pm/bulkPmDialog';
import { Col, Container, Row } from '../../../grid';
import { Tab, Tabs } from '../../molecules/tab';
import NewBulkPM from './new';
import ViewBulkPM from './view';
import DismissibleCallout from '../..//organisms/callout/dismissible-callout';
import { useTerms } from '../../../contexts/terms';

type TabId = 'new' | 'view';

const PMBulkTabs = ({ header, triageCategory }: BulkPMPayload): JSX.Element => {
  const [tabId, setTabId] = useState('new');
  /**
   * Switch between tabs
   *
   * @param tabId one of type TabId
   */
  const changeTab = (tabId: TabId) => {
    setTabId(tabId);
  };
  return (
    <Tabs
      id="Pushes"
      className={triageCategory ? 'mt-3' : 'mt-6'}
      selectedTabId={tabId}
      onChange={changeTab}
      renderActiveTabPanelOnly
    >
      <Tab
        id="new"
        title="New Bulk Push Message"
        panel={<NewBulkPM header={header} triageCategory={triageCategory} />}
      />
      <Tab id="view" title="Sent Bulk Push Messages" panel={<ViewBulkPM />} />
    </Tabs>
  );
};

const PMBulkPage = ({ header, triageCategory }: BulkPMPayload): JSX.Element => {
  const { terms } = useTerms();
  return (
    <React.Fragment>
      <Meta title="Bulk Push Messages" />
      {!triageCategory ? (
        <PageHeader icon={faShare} text="Bulk Push Messages" />
      ) : null}
      <DismissibleCallout
        intent="warning"
        message={`Any ${terms.patient.plural} that have opted out of the program that the bulk push message number is attached to will not receive push messages successfully.`}
      />
      <Container className={triageCategory ? '' : 'pa-6'}>
        <Row>
          <Col>
            <PMBulkTabs header={header} triageCategory={triageCategory} />
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
};

export default PMBulkPage;
